import { I18n } from '@calendly/i18n'
import { ArrowChevronDownMiniIcon } from '@calendly/ui/components/icons'
import { useState } from 'react'

import { Invitee } from './invitee'
import { ShowMoreButton } from './show_more_button'

const GUESTS_TO_SHOW = 3

export const SoloEvent = ({ event, readonly }) => {
  const guests = event?.eventGuestEmails || []
  const [isExpanded, setExpanded] = useState(guests.length <= GUESTS_TO_SHOW)

  const guestsToShow = isExpanded ? guests : guests.slice(0, GUESTS_TO_SHOW)

  return (
    <div>
      <Invitee event={event} invitee={event.invitee} readonly={readonly} />
      {guestsToShow.map((email) => (
        <Invitee key={email} event={event} invitee={{ email, name: email }} readonly={readonly} />
      ))}
      {guests.length > GUESTS_TO_SHOW && !isExpanded && (
        <ShowMoreButton event={event} expand={() => setExpanded(true)}>
          {String(I18n.t('publisher.meetings.invitees.view_more_guests', { count: guests.length - GUESTS_TO_SHOW }))}
          <ArrowChevronDownMiniIcon />
        </ShowMoreButton>
      )}
    </div>
  )
}
